module.exports = __webpack_public_path__ + "static/media/m8.b6ab579f.jpg";